var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',_vm._l((_vm.groups),function(group,g){return _c('group',{key:g,attrs:{"group":group}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }